import { useRef, useState } from "react";
import styles from "./LottieWrapper.module.scss";
import { LottieInt, RefInt } from "interfaces";
import Lottie from "./components/Lottie";
import { useLottieAnimations } from "animations";
import FullLoader from "components/FullLoader/FullLoader";

type props = {
  lotties: Array<LottieInt>;
  selector?: any;
  exportOffsets?: Function;
  upperOffset?: any;
};

const LottieWrapper = ({
  lotties,
  selector,
  exportOffsets,
  upperOffset,
}: props) => {
  const ref: RefInt = useRef(null!);

  const [steps, _setSteps] = useState<any>([]),
    exportSteps = (response: any) => {
      _setSteps(response.steps);
    };
  useLottieAnimations(ref, exportSteps, exportOffsets, !!selector);

  return (
    <div id="lottie-wrapper" className={styles.wrapper}>
      <div
        className="visually-hidden"
        aria-label="the following animation cannot be accessed via keyboard controls"
      />
      {selector && selector}
      <div
        id="lottie"
        ref={ref}
        className={`${styles.lotties} ${selector ? styles.selector : ""}`}
      >
        <FullLoader className="anim-fullLoader" />

        {lotties.map((lottie: LottieInt, i) => (
          <Lottie
            key={i}
            {...lottie}
            index={i}
            selector={!!selector}
            steps={steps[i]}
            upperOffset={upperOffset}
          />
        ))}
      </div>
    </div>
  );
};

export default LottieWrapper;
